<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">List Policies And Forms</div>
                <button type="submit" v-on:click.prevent="addLeadershipDevelopment" class="btn btn-primary waves-effect pull-right">Add</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                    <!-- List Content Here -->
                    <vue-good-table
                        ref="policiesFormsList"
                        mode="remote"
                        title="List Policies And Forms"
                        @on-page-change="onPageChange"
                        @on-selected-rows-change="selectionChanged"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                        }"
                        :selectOptions="{
                        enabled: true,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                        }"

                        :search-options="{
                        enabled: false,
                        }">

                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <!--class="btn btn-xs btn-primary"-->
                                <div v-if="props.column.field == 'action'" class="table-action">
                                    <a title='Delete Policies And Forms' id="delete" class="pull-right btn edit-btn-vvg waves-effect"  v-on:click.prevent="deletePoliciesAndForms(props.row.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                                    <router-link title='View Policies And Forms' class="pull-right btn edit-btn-vvg waves-effect" v-bind:to="{name: 'ViewUpdatePoliciesForms',params:{id:props.row.id}}"><i class="fa fa-eye" aria-hidden="true"></i></router-link>
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>

                        <div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <button id="deleteMultiple" class="btn btn-primary" v-on:click.prevent="deletePoliciesAndForms()">Delete Policies And Froms ({{selectedRows}})</button>
                        </div>

                    </vue-good-table>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';

    var self;
    export default {
        name: 'ListDiscounts',
        components: {
            'app-backend-footer': BackendFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                firstLoad: 0,
                columns: [
//                    {
//                        label: 'ID',
//                        field: 'id',
//                        filterable: true,
//                        filterOptions: {
//                            enabled: true, // enable filter for this column
//                            placeholder: "ID", // placeholder for filter input
//                            filterValue: '', // initial populated value for this filter
//                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
//                            filterFn: this.onColumnFilter, //custom filter function that
//                            trigger: "enter" //only trigger on enter not on keyup
//                        }
//                    },
                    {
                        label: 'Title',
                        field: 'title',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Title", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'State',
                        field: 'location',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "State", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Role',
                        field: 'role',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Role", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    // {
                    //     label: 'Contact Email',
                    //     field: 'contact_email',
                    //     filterable: true,
                    //     filterOptions: {
                    //         enabled: true, // enable filter for this column
                    //         placeholder: "Contact Email", // placeholder for filter input
                    //         filterValue: '', // initial populated value for this filter
                    //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    //         filterFn: this.onColumnFilter, //custom filter function that
                    //         trigger: "enter" //only trigger on enter not on keyup
                    //     }
                    // },
                    // {
                    //     label: 'Contact Number',
                    //     field: 'contact_number',
                    //     filterable: true,
                    //     filterOptions: {
                    //         enabled: true, // enable filter for this column
                    //         placeholder: "Contact Number", // placeholder for filter input
                    //         filterValue: '', // initial populated value for this filter
                    //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    //         filterFn: this.onColumnFilter, //custom filter function that
                    //         trigger: "enter" //only trigger on enter not on keyup
                    //     }
                    // },
                    {
                        label: 'Updated By',
                        field: 'updated_by',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Updated By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            //self.checkLogin();
        },
        mounted: function () {
//            self = this;
            self.showLoader();
            self.loadPoliciesAndForms();
            self.loadLocationsAdd();
        },
        methods: {
            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.locationArr = [];
                            // self.locationArr = response.data.content;

                            $.each(response.data.content, function (i) {
                                self.locationArr.push(response.data.content[i].text);
                            });
                            /*$.each(response.data.content, function (i) {
                             if (response.data.content[i].value == 0) {
                             self.locationArr.push(response.data.content[i]);
                             }
                             });
                             $.each(response.data.content, function (i) {
                             if (response.data.content[i].value != 0) {
                             self.locationArr.push(response.data.content[i]);
                             }
                             });*/
                            $.each(self.columns, function (i) {
                                if (self.columns[i].field == 'location') {
                                    self.columns[i].filterOptions.filterDropdownItems = self.locationArr;
                                }
                            });
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            addLeadershipDevelopment() {
                self.$router.push('/backend/addpolicesandforms');
            },

            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadPoliciesAndForms();
            },
            //
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadPoliciesAndForms();
                }
            },

            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('title');
                    field: ('location');
                    field: ('role');
                    field: ('contact_email');
                    field: ('contact_number');
                    field: ('updated_by');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.id || filters.title || filters.contact_email || filters.contact_number || filters.role || filters.location || filters.updated_by) {
                    self.loadPoliciesAndForms();
                }

            },
            selectionChanged() {
                self.selectedRows = (self.$refs['policiesFormsList'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadPoliciesAndForms();
            },

            deletePoliciesAndForms: function (id) {
                var usedArr = [];

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                if (id) {
                    usedArr.push(id);
                } else {
                    var selectedUser = self.$refs['policiesFormsList'].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        usedArr.push(this.$refs['policiesFormsList'].selectedRows[i].id);
                    }
                }
                var fields = {
                    deleteArr: usedArr,
                };

                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post("deletepoliciesandforms", fields, config)
                                .then(function (response) {
                                    self.loadPoliciesAndForms();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal('Deleted', 'You successfully deleted the record(s).', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your record(s) still intact', 'info')
                    }
                });
            },

            loadPoliciesAndForms: function () {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    messageData: self.message,
                    sort: self.serverParams.sort
                };
                self.showLoader();
                HTTP.post('listpoliciesforms', fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;

                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                if (response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            }
                            self.hideLoader();
                        })
            },

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/policiesandforms/ListPoliciesAndForms.vue